import {makeAutoObservable} from "mobx";

export default class ConsignesStore {
    viewHome = true;
    viewAddConsigne = false;
    viewPhoto = false;
    viewHistory = false;
    viewParametre = false;
    consigneData = [];

    constructor() {
        makeAutoObservable(this);
    }

    resetViews(){
       // this.viewHome = false;
        this.viewAddConsigne = false;
        this.viewPhoto = false;
        this.viewHistory = false;
        this.viewParametre = false;
        //this.consigneData = [];
    }
    handleViewHome(){
        this.resetViews();
        this.viewHome = true;
    }

    handleViewAddConsigne(){

      this.resetViews();
      //this.viewAddConsigne = true;
      //if (data){
      //    this.consigneData = data;
      //}
        this.viewAddConsigne = true;
    }

    handleViewPhoto(){
        this.resetViews();
        this.viewPhoto = true;
    }

    handleViewHistory(){
        this.resetViews();
        this.viewHistory = true;
    }

    handleViewGestion(){
        this.resetViews();
        this.viewParametre = true;
    }

}